module.exports = __webpack_public_path__ + "static/media/Covid.9dd256d7.png";